import { List, Typography } from 'antd';
import { customizeRenderEmpty } from 'components/common';
import React from 'react';
import VirtualList from 'rc-virtual-list';
import OmniChannelLeadChatOngoingItem from './OmniChannelLeadChatOngoingItem';
import { InView } from 'react-intersection-observer';
import OmniChannelLeadChatOngoingItemSkeleton from './OmniChannelLeadChatOngoingItemSkeleton';
import { formatNumber } from 'utils';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import { ChatSessionDto } from 'types';
import { omniChatMessages } from 'messages';
import OmniChannelLeadChatHistoriesFilterForm from './OmniChannelLeadChatHistoriesFilterForm';

type Props = {
  onSelectCustomer?: (value?: ChatSessionDto) => void;
  selectedCustomerId?: number;
};

const renderSkeletonItems = () => {
  return Array.from({ length: 5 }).map((_, index) => (
    <div key={`skeleton-${index}`} className='w-full border-b'>
      <OmniChannelLeadChatOngoingItemSkeleton />
    </div>
  ));
};

const OmniChannelLeadChatOngoingList: React.FC<Props> = ({}) => {
  const { chatSessionOngoing, handleLoadMoreOngoing, setChatOngoing, chatOngoing, countOngoing, hasMoreOngoing } =
    useOmniHistoriesLeadManageContext();

  const handleInViewChange = (isVisible: boolean) => {
    if (isVisible) {
      handleLoadMoreOngoing();
    }
  };

  const handleSelectChatSession = (session: ChatSessionDto) => {
    setChatOngoing(session);
  };
  const renderChatSession = (item: ChatSessionDto, index: number, onClick: (item: ChatSessionDto) => void) => {
    return (
      <div className='h-auto w-full p-0' key={item.chatSessionId}>
        <OmniChannelLeadChatOngoingItem
          onClick={() => onClick(item)}
          item={item}
          active={chatOngoing?.chatSessionId === item?.chatSessionId}
        />
      </div>
    );
  };

  return (
    <div className='flex max-h-[calc(100vh-180px)] flex-1 flex-col overflow-hidden'>
      <div className='flex h-16 shrink-0 items-center border-b px-5'>
        <Typography.Text className='mb-0 text-lg font-semibold'>
          <span className='text-2xl'>{formatNumber(countOngoing ?? 0)} </span>
          {omniChatMessages.chatSession}
        </Typography.Text>
      </div>
      <OmniChannelLeadChatHistoriesFilterForm />
      {!chatSessionOngoing || chatSessionOngoing.length === 0 ? (
        <div className='flex max-h-[calc(100vh-180px)] flex-1 flex-col overflow-hidden px-5'>
          <div className='flex items-center justify-center pt-[88px]'>{customizeRenderEmpty()}</div>
        </div>
      ) : null}

      <List className='max-h-full w-full flex-1 overflow-auto pb-6'>
        <VirtualList itemKey='chatSessionId' data={chatSessionOngoing} fullHeight>
          {(item: ChatSessionDto, index: number) => renderChatSession(item, index, handleSelectChatSession)}
        </VirtualList>
        {hasMoreOngoing && <InView onChange={handleInViewChange}>{renderSkeletonItems()}</InView>}
      </List>
    </div>
  );
};
export default OmniChannelLeadChatOngoingList;
